module.exports = __webpack_public_path__ + "img/redesign-funnel.f56ea637.svg";